
import ServiceContainer from '@flashpointbv/solar-service-container';
import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-configurable',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({default: false}) private readonly hideSingleOption: boolean;
  @Prop({default: false}) private readonly showPriceOption: boolean;
  @Prop({default: false}) private readonly showQtyOption: boolean;

  private get availableAttributes(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/availableAttributes'];
  }

  private get checkSingleProduct(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/checkSingleProduct'];
  }

  private get currentStep(): number {
    return this.$store.getters['CatalogConfigurableProduct/currentStep'];
  }
}
